var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 7.5H7.5V74.5H74.5V7.5Z",
    stroke: "#D3FF9A",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15C11.6421 15 15 11.6421 15 7.5C15 3.35786 11.6421 0 7.5 0C3.35786 0 0 3.35786 0 7.5C0 11.6421 3.35786 15 7.5 15Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5C10.8137 13.5 13.5 10.8137 13.5 7.5C13.5 4.18629 10.8137 1.5 7.5 1.5C4.18629 1.5 1.5 4.18629 1.5 7.5C1.5 10.8137 4.18629 13.5 7.5 13.5Z",
    stroke: "#D3FF9A",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 82C11.6421 82 15 78.6421 15 74.5C15 70.3579 11.6421 67 7.5 67C3.35786 67 0 70.3579 0 74.5C0 78.6421 3.35786 82 7.5 82Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 80.5C10.8137 80.5 13.5 77.8137 13.5 74.5C13.5 71.1863 10.8137 68.5 7.5 68.5C4.18629 68.5 1.5 71.1863 1.5 74.5C1.5 77.8137 4.18629 80.5 7.5 80.5Z",
    stroke: "#D3FF9A",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 82C78.6421 82 82 78.6421 82 74.5C82 70.3579 78.6421 67 74.5 67C70.3579 67 67 70.3579 67 74.5C67 78.6421 70.3579 82 74.5 82Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 80.5C77.8137 80.5 80.5 77.8137 80.5 74.5C80.5 71.1863 77.8137 68.5 74.5 68.5C71.1863 68.5 68.5 71.1863 68.5 74.5C68.5 77.8137 71.1863 80.5 74.5 80.5Z",
    stroke: "#D3FF9A",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 15C78.6421 15 82 11.6421 82 7.5C82 3.35786 78.6421 0 74.5 0C70.3579 0 67 3.35786 67 7.5C67 11.6421 70.3579 15 74.5 15Z",
    fill: "#1E1E1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 13.5C77.8137 13.5 80.5 10.8137 80.5 7.5C80.5 4.18629 77.8137 1.5 74.5 1.5C71.1863 1.5 68.5 4.18629 68.5 7.5C68.5 10.8137 71.1863 13.5 74.5 13.5Z",
    stroke: "#D3FF9A",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentIcon);
export default __webpack_public_path__ + "static/media/equipment-icon.8415fe492165e077cd84827de2d361b8.svg";
export { ForwardRef as ReactComponent };